<script>
    import AddressEdit from '../../business/address/AddressEdit.vue';
    import { CHECKOUT_STEPS } from '../../../script/store/checkout/consts';
    import { readCookie } from '../../../script/common';
    import { getCustomerAddressService } from '../../../service/resource';
    import Alert from '../../surface/alert/Alert.vue';
    import store from '../../../script/store/checkout';
    import ConfirmationModal from '../../../componentsV2/surface/confirmation-modal/ConfirmationModal.vue';

    export default {
        name: 'BaseCheckoutAddress',

        components: { ConfirmationModal, Alert, AddressEdit },

        props: {
            summarize: Boolean,
        },

        data() {
            return {
                ...CHECKOUT_STEPS,

                storeState: store.state,

                loading: false,

                addresses: null,
                selectedAddress: null,
                addressToEdit: false,
                addressToDelete: null,
                deleting: false,

                ownError: null,
            };
        },

        watch: {
            activeStep: {
                immediate: true,
                handler(to, from) {
                    if (to === this.STEP_ADDRESS) {
                        this.fetchAddresses();
                        if (from < this.STEP_ADDRESS && this.selectedAddress) {
                            store.step.next();
                        }
                    } else if (to < this.STEP_ADDRESS) {
                        this.selectedAddress = null;
                        this.addresses = null;
                    }
                },
            },

            cart: {
                immediate: true,
                handler(to) {
                    const address = (to.address || {}).data;

                    if (to && !this.selectedAddress && !this.addresses && address) {
                        this.selectedAddress = address;
                        this.addresses = [this.selectedAddress];
                    }
                },
            },
        },

        computed: {
            cart() {
                return this.storeState.cart.cart;
            },

            customer() {
                return (this.cart.customer || {}).data;
            },

            activeStep() {
                return this.storeState.step.active;
            },

            storeError() {
                if (this.storeState.address.error) {
                    return this.storeState.address.error.i18n
                        ? this.$t(this.storeState.address.error.msg)
                        : this.storeState.address.error.msg;
                } else {
                    return null;
                }
            },

            alert() {
                return this.ownError || this.storeError
                    ? {
                        message: this.ownError || this.storeError,
                        isError: true,
                        timeout: 30000,
                    }
                    : null;
            },

            title() {
                if (this.addressToEdit)
                    return this.addressToEdit.address_id ? 'Edição de endereço' : 'Novo endereço';
                else return 'Endereço';
            },

            fastLoginEmail() {
                return this.storeState.authentication.fastLoginEmail;
            },

            customerAddressService() {
                return getCustomerAddressService(this.customer.id);
            },

            isLoading() {
                return this.loading || this.storeState.address.requests > 0;
            },
        },

        methods: {
            fetchAddresses() {
                this.loading = true;

                this.customerAddressService
                    .query(
                        {},
                        {
                            headers: {
                                'cr-api-fast-auth': this.fastLoginEmail,
                            },
                        }
                    )
                    .then((response) => {
                        this.addresses = response.data.data;

                        if (!this.addresses || this.addresses.length === 0) this.createAddress();

                        if (((this.cart || {}).address || {}).data) {
                            let selectedAddress = this.addresses.find(
                                (a) => a.address_id === this.cart.address.data.address_id
                            );

                            if (!selectedAddress) {
                                selectedAddress = this.cart.address.data;
                                this.addresses.unshift(this.cart.address.data);
                            }

                            this.selectedAddress = selectedAddress;
                        }

                        this.$emit('loaded');
                    })
                    .catch(
                        () => (this.ownError = this.$t('_checkout._address.errorFetchingAddresses'))
                    )
                    .then(() => (this.loading = false));
            },

            createAddress() {
                store.authentication.authGuard(() => {
                    this.addressToEdit = {
                        phone_1:
                            this.customer.phone && this.customer.phone !== '0'
                                ? this.customer.phone
                                : null,
                        zip_code: readCookie('cep'),
                    };
                });
            },

            editAddress(address) {
                store.authentication.authGuard(() => {
                    this.addressToEdit = address;
                });
            },

            setAddressToDelete(address) {
                store.authentication.authGuard(() => {
                    this.addressToDelete = address;
                });
            },

            onEditCancel() {
                this.addressToEdit = null;
            },

            onEditError(error) {
                // atribui null e usa nextTick pra forçar a exibição do alerta caso o erro seja igual ao anterior
                this.ownError = null;
                this.$nextTick(() => (this.ownError = error));
            },

            onEditSuccess(address) {
                this.ownError = null;
                this.addressToEdit = null;

                for (let i = 0; i < this.addresses.length; i++) {
                    if (this.addresses[i].address_id === address.address_id) {
                        this.addresses.splice(i, 1, address);
                        this.selectAddress(address);
                        return;
                    }
                }

                this.addresses.unshift(address);
                this.selectAddress(address);
            },

            selectAddress(address) {
                this.ownError = null;
                this.selectedAddress = address;
                store.address.select(address);
            },

            deleteAddress() {
                this.deleting = true;

                this.customerAddressService
                    .delete(this.addressToDelete.address_id)
                    .then(() => {
                        this.ownError = this.$t('_address.successfullyDeletedX', [
                            this.addressToDelete.alias,
                        ]);
                        this.fetchAddresses();
                    })
                    .catch(() => (this.ownError = this.$t('_address.errorDeleting')))
                    .then(() => {
                        this.addressToDelete = null;
                        this.deleting = false;
                    });
            },
        },
    };
</script>
